module.exports = __webpack_public_path__ + "img/vespa_190.ce267b3c.png";